import React, {Fragment} from 'react';
import SmartNumber from "./SmartNumber.jsx";
import SmartGeneral from "./SmartGeneral.jsx";

const registers = [1, 2, 3, 4, 5, 6]
export default function SmartTOUPricesAndTimesForRegisters(props) {
    return (
        registers.map(register => {
            return (
                <Fragment>
                    <p><b>Register {register}:</b></p>
                    <SmartNumber
                        label="Pence Per kWh"
                        name={`consumption_in_pence_per_kwh_for_register_${register}`}
                        placeholder="Enter the pence per kWh"
                        required={register < 3}
                        min={props.min}
                        max={props.max}
                        step=".01"
                        pattern="^([\d]{1,3})(\.[\d]{1,2})?$"
                        title="Enter the energy price in pence per kWh"
                        feedback={`Enter a number between ${props.min} and ${props.max} (up to 2 decimal places).`}
                    />
                    <SmartGeneral
                        label="Weekday Start Times"
                        name={`weekday_start_times_for_register_${register}`}
                        placeholder="Enter a comma separted list of the times at which this register is to start being used on each week day in HH:MM format e.g. 09:00, 17:00"
                        title="Weekday Start Times"
                        pattern="^(?:[01]\d|2[0-3]):[0-5]\d(?:\s*,\s*(?:[01]\d|2[0-3]):[0-5]\d)*$"
                        feedback="Enter a comma separted list of the times at which this register is to start being used on each week day in HH:MM format e.g. 09:00, 17:00"
                    />
                    <SmartGeneral
                        label="Weekend Start Times"
                        name={`weekend_start_times_for_register_${register}`}
                        placeholder="Enter a comma separted list of the times at which this register is to start being used on each weekend day in HH:MM format e.g. 09:00, 17:00"
                        title="Weekend Start Times"
                        pattern="^(?:[01]\d|2[0-3]):[0-5]\d(?:\s*,\s*(?:[01]\d|2[0-3]):[0-5]\d)*$"
                        feedback="Enter a comma separted list of the times at which this register is to start being used on each weekend day in HH:MM format e.g. 09:00, 17:00"
                    />
                </Fragment>
            )
        }))
}

